<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">User Management</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage application users across programs.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} users found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showAddButton) {
          <a
            routerLink="/create-user"
            class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>person_add</mat-icon>
            Add User
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.userKeyword" placeholder="Name or email" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Role</mat-label>
            <mat-select placeholder="All Roles" name="filterprogram" [(ngModel)]="queryFilter.role">
              <mat-option value="0">All Roles</mat-option>
              @for (ar of applicationRoles; track ar) {
                <mat-option [value]="ar.id">{{ ar.description }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filtercoursestatus" [(ngModel)]="queryFilter.status">
              <mat-option value="ALL">All Statuses</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="INACTIVE">Inactive</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Program</mat-label>
            <mat-select placeholder="All Programs" name="filterprogramselect" [(ngModel)]="queryFilter.participantProgram">
              <mat-option value="0">All Programs</mat-option>
              @for (p of programs; track p) {
                <mat-option [value]="p.id">{{ p.programName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="userstable; context: { data: users, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="User list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #userstable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let user">
        <div class="user-mgmt-page__user-cell">
          <span class="user-mgmt-page__avatar">{{ getInitials(user.name) }}</span>
          <a [routerLink]="['/view-user', user.id]" class="user-mgmt-page__user-link">{{ user.name }}</a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Roles">
      <th mat-header-cell *matHeaderCellDef>Roles</th>
      <td mat-cell *matCellDef="let user">
        @if (user.roles?.length) {
          <ul class="user-mgmt-page__chip-list">
            @for (item of user.roles; track item) {
              <li>
                <span class="user-mgmt-page__chip">{{ item }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="user-mgmt-page__empty-text">No roles</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="Program">
      <th mat-header-cell *matHeaderCellDef>Program</th>
      <td mat-cell *matCellDef="let user">
        @if (user.participantPrograms?.length) {
          <ul class="user-mgmt-page__chip-list">
            @for (item of user.participantPrograms; track item) {
              <li>
                <span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ item }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="user-mgmt-page__empty-text">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="lastactive">
      <th mat-header-cell *matHeaderCellDef class="w-130">Last Active</th>
      <td mat-cell *matCellDef="let user">{{ user.lastActiveDate || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let user">
        <app-status-bubble [status]="user.status"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
